var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm._t(
        "default",
        function () {
          return [
            _c("ContractorsMultiselect", {
              class: _vm.multiselectClasses,
              attrs: {
                value: _vm.value,
                contractorsConditions: _vm.contractorsConditions,
                disabled: _vm.disabled,
                invalid: _vm.isError,
              },
              on: { input: _vm.updateSelectedEmployees, close: _vm.onClose },
            }),
          ]
        },
        {
          disabled: _vm.disabled,
          invalid: _vm.isError,
          value: _vm.value,
          updateSelectedEmployees: _vm.updateSelectedEmployees,
          onClose: _vm.onClose,
        }
      ),
      _vm.isError
        ? _c("FormGroupError", {
            staticClass: "pt-1",
            attrs: { error: _vm.error },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }